module.exports = __webpack_public_path__ + "media/images/notification-toggle-up-7b3413896d7da3b07b964386cc6f5279.svg";